import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PanitiaProtectedRouteProps {
  children: React.ReactNode;
}

const PanitiaProtectedRoute: React.FC<PanitiaProtectedRouteProps> = ({ children }) => {
  const { panitia, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!panitia) {
    return <Navigate to="/panitia-login" replace />;
  }

  return <>{children}</>;
};

export default PanitiaProtectedRoute; 